export const APP_NAME = 'Re.Monster'
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 30, 50]
export const NOTIFICATION_DURATION = 3
export const IMAGE_FALLBACK =
  'data:image/png;base64,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'

export const ALLOW_AVATAR_TYPES = ['image/jpeg', 'image/png', 'image/heic']
export const SCREEN_SIZE = {
  MOBILE: '(max-width: 600px)',
  TABLET: '(max-width: 800px)',
  DESKTOP: '(max-width: 1920px)',
}

export const FARM_SORT_USER = [
  {
    key: '0',
    label: 'ID',
    valueLanguage: 'ID',
    value: 'farm_nft_id',
  },
  {
    key: '1',
    label: 'Total Parameter',
    valueLanguage: 'Total Parameter',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: 'Max Parameter',
    valueLanguage: 'Max Parameter',
    value: 'maximumTotalParameter',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
  {
    key: '9',
    label: 'Fatigue',
    valueLanguage: 'Fatigue',
    value: 'farm_fatigue_enhance_value',
  },
  {
    key: '10',
    label: 'Stress',
    valueLanguage: 'Stress',
    value: 'farm_stress_enhance_value',
  },
  {
    key: '11',
    label: 'Rest',
    valueLanguage: 'Rest',
    value: 'farm_rest_enhance_value',
  },
]
export const FARM_SORT_USER_JA = [
  {
    key: '0',
    label: 'ID',
    valueLanguage: 'ID',
    value: 'farm_nft_id',
  },
  {
    key: '1',
    label: '総パラメータ',
    valueLanguage: 'Total Parameter',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: '最大パラメータ',
    valueLanguage: 'Max Parameter',
    value: 'maximumTotalParameter',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
  {
    key: '9',
    label: '疲労度',
    valueLanguage: 'Fatigue',
    value: 'farm_fatigue_enhance_value',
  },
  {
    key: '10',
    label: 'ストレス軽減',
    valueLanguage: 'Stress',
    value: 'farm_stress_enhance_value',
  },
  {
    key: '11',
    label: '休憩',
    valueLanguage: 'Rest',
    value: 'farm_rest_enhance_value',
  },
]

export const FARM_SORT_SALE_USER = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },

  {
    key: '1',
    label: 'Total Parameter',
    valueLanguage: 'Total Parameter',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: 'Max Parameter',
    valueLanguage: 'Max Parameter',
    value: 'maximumTotalParameter',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
]
export const FARM_SORT_SALE_USER_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },

  {
    key: '1',
    label: '総パラメータ',
    valueLanguage: 'Total Parameter',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: '最大パラメータ',
    valueLanguage: 'Max Parameter',
    value: 'maximumTotalParameter',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
]

export const MONSTER_SORT_USER = [
  {
    key: '0',
    label: 'ID',
    valueLanguage: 'ID',
    value: 'monster_nft_id',
  },
  {
    key: '1',
    label: 'Overall',
    valueLanguage: 'Overall',
    value: 'overall',
  },
  {
    key: '2',
    label: 'Monster Rank',
    valueLanguage: 'Monster Rank',
    value: 'monster_rank',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'alter_basic_p.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'alter_basic_p.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'alter_basic_p.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'alter_basic_p.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'alter_basic_p.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'alter_basic_p.vitality',
  },
  {
    key: '9',
    label: 'Lifespan',
    valueLanguage: 'Lifespan',
    value: 'life_span',
  },
  {
    key: '10',
    label: 'Battle Count',
    valueLanguage: 'Battle Count',
    value: 'battle_count',
  },
]
export const MONSTER_SORT_USER_JA = [
  {
    key: '0',
    label: 'ID',
    valueLanguage: 'ID',
    value: 'monster_nft_id',
  },
  {
    key: '1',
    label: '総合力',
    valueLanguage: 'Overall',
    value: 'overall',
  },
  {
    key: '2',
    label: 'モンスターランク',
    valueLanguage: 'Monster Rank',
    value: 'monster_rank',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'alter_basic_p.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'alter_basic_p.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'alter_basic_p.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'alter_basic_p.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'alter_basic_p.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'alter_basic_p.vitality',
  },
  {
    key: '9',
    label: '寿命',
    valueLanguage: 'Lifespan',
    value: 'life_span',
  },
  {
    key: '10',
    label: 'Battle Count',
    valueLanguage: 'Battle Count',
    value: 'battle_count',
  },
]
export const FARM_TERRAIN = {
  NONE: 0,
  PLAIN: 1,
  FOREST: 2,
  WATERFRONT: 3,
  DESERT: 4,
  WILDLAND: 5,
  MOUNTAIN: 6,
  VOLCANO: 7,
}
export const MONSTER_SORT_SALE_USER = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: 'Overall',
    valueLanguage: 'Overall',
    value: 'overall',
  },
  {
    key: '2',
    label: 'Monster Rank',
    valueLanguage: 'Monster Rank',
    value: 'monster_rank',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'alter_basic_p.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'alter_basic_p.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'alter_basic_p.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'alter_basic_p.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'alter_basic_p.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'alter_basic_p.vitality',
  },
]
export const MONSTER_SORT_SALE_USER_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: '総合力',
    valueLanguage: 'Overall',
    value: 'overall',
  },
  {
    key: '2',
    label: 'モンスターランク',
    valueLanguage: 'Monster Rank',
    value: 'monster_rank',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'alter_basic_p.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'alter_basic_p.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'alter_basic_p.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'alter_basic_p.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'alter_basic_p.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'alter_basic_p.vitality',
  },
]

export const ITEM_SORT_USER = [
  {
    key: '0',
    label: 'Quality',
    valueLanguage: 'Quality',
    value: 'quality',
  },
  {
    key: '1',
    label: 'Quantity',
    valueLanguage: 'Quantity',
    value: 'quantity',
  },
]
export const ITEM_SORT_USER_JA = [
  {
    key: '0',
    label: '品質',
    valueLanguage: 'Quality',
    value: 'quality',
  },
  {
    key: '1',
    label: '数量',
    valueLanguage: 'Quantity',
    value: 'quantity',
  },
]

export const ITEM_SORT_SALE_USER = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'price',
  },
  {
    key: '1',
    label: 'Quality',
    valueLanguage: 'Quality',
    value: 'quality',
  },
]
export const ITEM_SORT_SALE_USER_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'price',
  },
  {
    key: '1',
    label: '品質',
    valueLanguage: 'Quality',
    value: 'quality',
  },
]

export const GENESIS_SORT_SALE_USER = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
]
export const GENESIS_SORT_SALE_USER_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
]

export const GENERAL_SORT_SALE_USER = [
  {
    key: '0',
    label: 'Price',
    value: 'sort_by_price',
  },
]

export const ITEM_SORT = [
  {
    key: '0',
    label: 'price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: 'overallAbility',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '3',
    label: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '4',
    label: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '5',
    label: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '6',
    label: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '7',
    label: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
]

export const ITEM_SORT_MKP = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'price',
  },
  {
    key: '1',
    label: 'Quality',
    valueLanguage: 'Quality',
    value: 'quality',
  },
]
export const ITEM_SORT_MKP_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'price',
  },
  {
    key: '1',
    label: '品質',
    valueLanguage: 'Quality',
    value: 'quality',
  },
]

export const HASH_SORT_MKP = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
]
export const HASH_SORT_MKP_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
]

export const MONSTER_SORT_MKP = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: 'Overall',
    valueLanguage: 'Overall',
    value: 'overall',
  },
  {
    key: '2',
    label: 'Monster Rank',
    valueLanguage: 'Monster Rank',
    value: 'monster_rank',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'alter_basic_p.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'alter_basic_p.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'alter_basic_p.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'alter_basic_p.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'alter_basic_p.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'alter_basic_p.vitality',
  },
  // {
  //   key: '8',
  //   label: 'ST Recovery',
  //   value: 'innate_trait_id_list.innate_trait_id',
  // },

  {
    key: '9',
    label: 'Lifespan',
    valueLanguage: 'Lifespan',
    value: 'life_span',
  },
  {
    key: '10',
    label: 'Battle Count',
    valueLanguage: 'Battle Count',
    value: 'battle_count',
  },
]
export const MONSTER_SORT_MKP_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: '総合力',
    valueLanguage: 'Overall',
    value: 'overall',
  },
  {
    key: '2',
    label: 'モンスターランク',
    valueLanguage: 'Monster Rank',
    value: 'monster_rank',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'alter_basic_p.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'alter_basic_p.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'alter_basic_p.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'alter_basic_p.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'alter_basic_p.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'alter_basic_p.vitality',
  },
  // {
  //   key: '8',
  //   label: 'ST Recovery',
  //   value: 'innate_trait_id_list.innate_trait_id',
  // },

  {
    key: '9',
    label: '寿命',
    valueLanguage: 'Lifespan',
    value: 'life_span',
  },
  {
    key: '10',
    label: 'Battle Count',
    valueLanguage: 'Battle Count',
    value: 'battle_count',
  },
]

export const FARM_SORT_MKP = [
  {
    key: '0',
    label: 'Price',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: 'Total Parameter',
    valueLanguage: 'Total Parameter',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: 'Max Parameter',
    valueLanguage: 'Max Parameter',
    value: 'maximumTotalParameter',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
  {
    key: '9',
    label: 'Fatigue',
    valueLanguage: 'Fatigue',
    value: 'farm_fatigue_enhance_value',
  },
  {
    key: '10',
    label: 'Stress',
    valueLanguage: 'Stress',
    value: 'farm_stress_enhance_value',
  },
  {
    key: '11',
    label: 'Rest',
    valueLanguage: 'Rest',
    value: 'farm_rest_enhance_value',
  },
]
export const FARM_SORT_MKP_JA = [
  {
    key: '0',
    label: '価格',
    valueLanguage: 'Price',
    value: 'sort_by_price',
  },
  {
    key: '1',
    label: '総パラメータ',
    valueLanguage: 'Total Parameter',
    value: 'total_parameters',
  },
  {
    key: '2',
    label: '最大パラメータ',
    valueLanguage: 'Max Parameter',
    value: 'maximumTotalParameter',
  },
  {
    key: '3',
    label: 'HP',
    valueLanguage: 'HP',
    value: 'farm_basic_enhance_value.health',
  },
  {
    key: '4',
    label: 'STR',
    valueLanguage: 'STR',
    value: 'farm_basic_enhance_value.strength',
  },
  {
    key: '5',
    label: 'INT',
    valueLanguage: 'INT',
    value: 'farm_basic_enhance_value.intelligent',
  },
  {
    key: '6',
    label: 'DEX',
    valueLanguage: 'DEX',
    value: 'farm_basic_enhance_value.dexterity',
  },
  {
    key: '7',
    label: 'AGI',
    valueLanguage: 'AGI',
    value: 'farm_basic_enhance_value.agility',
  },
  {
    key: '8',
    label: 'VIT',
    valueLanguage: 'VIT',
    value: 'farm_basic_enhance_value.vitality',
  },
  {
    key: '9',
    label: '疲労度',
    valueLanguage: 'Fatigue',
    value: 'farm_fatigue_enhance_value',
  },
  {
    key: '10',
    label: 'ストレス軽減',
    valueLanguage: 'Stress',
    value: 'farm_stress_enhance_value',
  },
  {
    key: '11',
    label: '休憩',
    valueLanguage: 'Rest',
    value: 'farm_rest_enhance_value',
  },
]

export const okButtonStyle = {
  fontWeight: 'bold',
  padding: '10px',
  color: '#fff',
  backgroundColor: '#FAA52C',
  width: '50%',
  height: '48px',
  borderRadius: '4px',
}
export const cancelButtonStyle = {
  fontWeight: 'bold',
  padding: '10px',
  color: '#fff',
  width: '50%',
  height: '48px',
}

export const converSeed = (seed) => {
  switch (seed) {
    case 'Ame-chan':
      return 'Ame-chan(KawaiiGirl)'
    case 'Ame_chan':
      return 'Ame-chan(KawaiiGirl)'
    case 'AstarCats':
      return 'AstarCats'
    case 'CCT':
      return 'CCT(candyconytown)'
    case 'DEKAUSA':
      return 'DEKAUSA(ALKEMON)'
    case 'Faireaf':
      return 'Faireaf'
    case 'Golem':
      return 'Golem'
    case 'Icelime':
      return 'Icelime(EIEN)'
    case 'Hiyori':
      return 'Hiyori(Wafuku)'
    case 'KidsHero':
      return 'Kids Hero(Kids Fight)'
    case 'KidsVilain':
      return 'Kids Vilain(Kids Fight)'
    case 'Layla':
      return 'Layla(Love Addicted Girls)'
    case 'ODENPETS':
      return 'ODENPETS(ODENDAO)'
    case 'Ossan':
      return 'Ossan Paradise'
    case 'Ossan_Paradise':
      return 'Ossan Paradise'
    case 'ossan_paradise':
      return 'Ossan Paradise'
    case 'P1':
      return 'P1(X-soldiers)'
    case 'PlanetMan':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'SignWitch':
      return 'SignWitch(Astar Sign Witch)'
    case 'Tofu':
      return 'Tofu'
    case 'Unicorn':
      return 'Unicorn'
    case 'UPA':
      return 'UPA(Debreed)'
    case 'Valius':
      return 'Valius'
    case 'Yamato':
      return 'Yamato(1912)'
    case 'Ame-chan(KawaiiGirl)':
      return 'Ame-chan(KawaiiGirl)'
    case 'CCT(candyconytown)':
      return 'CCT(candyconytown)'
    case 'DEKAUSA(ALKEMON)':
      return 'DEKAUSA(ALKEMON)'
    case 'Hiyori(Wafuku)':
      return 'Hiyori(Wafuku)'
    case 'Icelime(EIEN)':
      return 'Icelime(EIEN)'
    case 'Kids Hero(Kids Fight)':
      return 'Kids Hero(Kids Fight)'
    case 'Kids Vilain(Kids Fight)':
      return 'Kids Vilain(Kids Fight)'
    case 'Layla(Love Addicted Girls)':
      return 'Layla(Love Addicted Girls)'
    case 'ODENPETS(ODENDAO)':
      return 'ODENPETS(ODENDAO)'
    case 'P1(X-soldiers)':
      return 'P1(X-soldiers)'
    case 'Sake Barrel PlanetMan(PlanetmMan)':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'SignWitch(Astar Sign Witch)':
      return 'SignWitch(Astar Sign Witch)'
    case 'UPA(Debreed)':
      return 'UPA(Debreed)'
    case 'Yamato(1912)':
      return 'Yamato(1912)'
    case 'Kids_Hero(Kids Fight)':
      return 'Kids Hero(Kids Fight)'
    case 'kids_hero(Kids Fight)':
      return 'Kids Hero(Kids Fight)'
    case 'Kids_Vilain(Kids Fight)':
      return 'Kids Vilain(Kids Fight)'
    case 'kids_vilain(Kids Fight)':
      return 'Kids Vilain(Kids Fight)'
    case 'Sake_Barrel_PlanetMan(PlanetmMan)':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'sake_barrel_planetMan(PlanetmMan)':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'Kids_Hero':
      return 'Kids Hero(Kids Fight)'
    case 'kids_hero':
      return 'Kids Hero(Kids Fight)'
    case 'Kids_Vilain':
      return 'Kids Vilain'
    case 'kids_vilain':
      return 'Kids Vilain'
    case 'Sake_Barrel_PlanetMan':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'sake_barrel_planetMan':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'Planetman':
      return 'Sake Barrel PlanetMan(PlanetmMan)'
    case 'ame_chan':
      return 'Ame-chan(KawaiiGirl)'
    case 'P_1':
      return 'P1(X-soldiers)'
    case 'p_1':
      return 'P1(X-soldiers)'
    case 'Kids_Villain':
      return 'Kids Vilain(Kids Fight)'
    case 'kids_villain':
      return 'Kids Vilain(Kids Fight)'
    default:
      return ''
  }
}
export const converImageGenesisBox = (type) => {
  switch (type) {
    case 'A':
      return 'genesis_A'
    case 'B':
      return 'genesis_B'
    case 'C':
      return 'genesis_C'
    case 'D':
      return 'genesis_D'
    case 'E':
      return 'genesis_E'
    default:
      return ''
  }
}
export const converImageGeneralBox = (type) => {
  switch (type) {
    case 'A':
      return 'GoldA'
    case 'B':
      return 'GoldB'
    case 'C':
      return 'GoldC'
    case 'D':
      return 'GoldD'
    case 'E':
      return 'GoldE'
    default:
      return ''
  }
}
export const converNameSeedShop = (seed) => {
  switch (seed) {
    case 'Ame-chan':
      return 'Ame-chan'
    case 'AstarCats':
      return 'AstarCats'
    case 'CCT':
      return 'CCT'
    case 'DEKAUSA':
      return 'DEKAUSA'
    case 'Faireaf':
      return 'Faireaf'
    case 'Golem':
      return 'Golem'
    case 'Icelime':
      return 'Icelime'
    case 'Hiyori':
      return 'Hiyori'
    case 'KidsHero':
      return 'Kids Hero'
    case 'KidsVilain':
      return 'Kids Vilain'
    case 'Layla':
      return 'Layla'
    case 'ODENPETS':
      return 'ODENPETS'
    case 'Ossan':
      return 'Ossan Paradise'
    case 'P1':
      return 'P1'
    case 'PlanetMan':
      return 'Sake Barrel Planet Man'
    case 'Planetman':
      return 'Sake Barrel Planet Man'
    case 'SignWitch':
      return 'Sign Witch'
    case 'Tofu':
      return 'Tofu'
    case 'Unicorn':
      return 'Unicorn'
    case 'UPA':
      return 'UPA'
    case 'Valius':
      return 'Valius'
    case 'Yamato':
      return 'Yamato'
    case 'Ame-chan(KawaiiGirl)':
      return 'Ame-chan'
    case 'CCT(candyconytown)':
      return 'CCT'
    case 'DEKAUSA(ALKEMON)':
      return 'DEKAUSA'
    case 'Hiyori(Wafuku)':
      return 'Hiyori'
    case 'Icelime(EIEN)':
      return 'Icelime'
    case 'Kids Hero(Kids Fight)':
      return 'Kids Hero'
    case 'Kids Vilain(Kids Fight)':
      return 'Kids Vilain'
    case 'Layla(Love Addicted Girls)':
      return 'Layla'
    case 'ODENPETS(ODENDAO)':
      return 'ODENPETS'
    case 'P1(X-soldiers)':
      return 'P1'
    case 'Sake Barrel PlanetMan(PlanetmMan)':
      return 'Sake Barrel Planet Man'
    case 'SignWitch(Astar Sign Witch)':
      return 'Sign Witch'
    case 'UPA(Debreed)':
      return 'UPA'
    case 'Yamato(1912)':
      return 'Yamato'
    case 'Kids_Hero(Kids Fight)':
      return 'Kids Hero'
    case 'Kids_Vilain(Kids Fight)':
      return 'Kids Vilain'
    case 'Sake_Barrel_PlanetMan(PlanetmMan)':
      return 'Sake Barrel Planet Man'
    case 'Kids_Hero':
      return 'Kids Hero'
    case 'Kids_Vilain':
      return 'Kids Vilain'
    case 'Sake_Barrel_PlanetMan':
      return 'Sake Barrel Planet Man'
    case 'Ame_chan':
      return 'Ame-chan'
    case 'P_1':
      return 'P1'
    case 'Ossan_Paradise':
      return 'Ossan Paradise'
    case 'Kids_Villain':
      return 'Kids Vilain'
    default:
      return ''
  }
}

export const convertImageMonster = (image) => {
  switch (image) {
    case 'Ame_chan_Ame_chan_1':
      return 'Amechan_1'
    case 'Ame_chan_Golem_1':
      return 'Amechan%20[Powered]'
    case 'Ame_chan_Hiyori_1':
      return 'Amechan%20[Wafuku]'
    case 'Ame_chan_Icelime_1':
      return 'Amechan%20[Summer]'
    case 'Ame_chan_Kids_Villain_1':
      return 'Amechan%20[Villain]'
    case 'Ame_chan_Layla_1':
      return 'Amechan%20[Imp]'
    case 'Ame_chan_Yamato_1':
      return 'Amechan%20[School]'
    case 'AstarCats_AstarCats_1':
      return 'AstarCat_1'
    case 'AstarCats_Faireaf_1':
      return 'AstarCat_FairyCat'
    case 'AstarCats_Hiyori_1':
      return 'AstarCat_WafukuCat'
    case 'AstarCats_Kids_Villain_1':
      return 'AstarCat_VillainCat'
    case 'AstarCats_Ossan_Paradise_1':
      return 'AstarCat_MaskCat'
    case 'AstarCats_SignWitch_1':
      return 'AstarCat_WitchCat'
    case 'AstarCats_Tofu_1':
      return 'AstarCat_TofuCat'
    case 'CCT_CCT_1':
      return 'CCT_Coni'
    case 'CCT_CCT_2':
      return 'CCT_Mous'
    case 'CCT_CCT_3':
      return 'CCT_Bot'
    case 'CCT_CCT_4':
      return 'CCT_Conic'
    case 'DEKAUSA_CCT_1':
      return 'Dekausa_DEKACONI'
    case 'DEKAUSA_DEKAUSA_1':
      return 'Dekausa_1'
    case 'DEKAUSA_Golem_1':
      return 'Dekausa_GOLIATH'
    case 'DEKAUSA_ODENPETS_1':
      return 'Dekausa_DEKALABY'
    case 'DEKAUSA_Planetman_1':
      return 'Dekausa_TARU-USA'
    case 'DEKAUSA_Tofu_1':
      return 'Dekausa_SOY'
    case 'DEKAUSA_Yamato_1':
      return 'Dekausa_BANCHO'
    case 'Faireaf_Ame_chan_1':
      return 'Faireaf_Cantis'
    case 'Faireaf_Faireaf_1':
      return 'Faireaf_1'
    case 'Faireaf_Layla_1':
      return 'Faireaf_Lilim'
    case 'Faireaf_P1_1':
      return 'Faireaf_Caliy'
    case 'Faireaf_SignWitch_1':
      return 'Faireaf_Aether'
    case 'Faireaf_Tofu_1':
      return 'Faireaf_Whisper'
    case 'Faireaf_Valius_1':
      return 'Faireaf_Wolfair'
    case 'Golem_DEKAUSA_1':
      return 'Rabilen_1'
    case 'Golem_Golem_1':
      return 'Golem_1'
    case 'Golem_Kids_Hero_1':
      return 'Patrolem_1'
    case 'Golem_Kids_Villain_1':
      return 'Pazuzu_1'
    case 'Golem_Ossan_Paradise_1':
      return 'Quackle_1'
    case 'Golem_Planetman_1':
      return 'Wooden_1'
    case 'Golem_UPA_1':
      return 'Wooden_1'
    case 'Hiyori_Ame_chan_1':
      return 'Hiyori_Nanami'
    case 'Hiyori_Faireaf_1':
      return 'Hiyori_Mei'
    case 'Hiyori_Hiyori_1':
      return 'Hiyori_1'
    case 'Hiyori_Icelime_1':
      return 'Hiyori_Yui'
    case 'Hiyori_Layla_1':
      return 'Hiyori_Ayano'
    case 'Hiyori_Unicorn_1':
      return 'Hiyori_Orika'
    case 'Hiyori_Valius_1':
      return 'Hiyori_Akane'
    case 'Icelime_CCT_1':
      return 'icelime_conintown'
    case 'Icelime_DEKAUSA_1':
      return 'icelime_dekausa'
    case 'Icelime_Icelime_1':
      return 'IceLime_Eien'
    case 'Icelime_Kids_Hero_1':
      return 'icelime_kidhero'
    case 'Icelime_Unicorn_1':
      return 'icelime_unicorn'
    case 'Icelime_UPA_1':
      return 'icelime_UPA'
    case 'Icelime_Yamato_1':
      return 'icelime_yamato'
    case 'Kids_Hero_Kids_Hero_1':
      return 'Kidsfight_KidsHero_1'
    case 'Kids_Hero_Kids_Hero_2':
      return 'Kidsfight_KidsHero_2'
    case 'Kids_Hero_Kids_Hero_3':
      return 'Kidsfight_KidsHero_3'
    case 'Kids_Hero_Kids_Hero_4':
      return 'Kidsfight_KidsHero_4'
    case 'Kids_Hero_Kids_Hero_5':
      return 'Kidsfight_KidsHero_5'
    case 'Kids_Villain_Kids_Villain_1':
      return 'Kidsfight_KidsVillian_1'
    case 'Kids_Villain_Kids_Villain_2':
      return 'Kidsfight_KidsVillian_2'
    case 'Kids_Villain_Kids_Villain_3':
      return 'Kidsfight_KidsVillian_3'
    case 'Kids_Villain_Kids_Villain_4':
      return 'Kidsfight_KidsVillian_4'
    case 'Kids_Villain_Kids_Villain_5':
      return 'Kidsfight_KidsVillian_5'
    case 'Layla_Faireaf_1':
      return 'Layla_Bella'
    case 'Layla_Hiyori_1':
      return 'Layla_Matoi'
    case 'Layla_Icelime_1':
      return 'Layla_Sora'
    case 'Layla_Layla_1':
      return 'Layla_1'
    case 'Layla_P1_1':
      return 'Layla_Eve'
    case 'Layla_SignWitch_1':
      return 'Layla_Olivia'
    case 'Layla_Valius_1':
      return 'Layla_Luna'
    case 'ODENPETS_Ame_chan_1':
      return 'ODENPETS_Kumatama'
    case 'ODENPETS_DEKAUSA_1':
      return 'ODENPETS_Laby'
    case 'ODENPETS_Kids_Hero_1':
      return 'ODENPETS_Monta'
    case 'ODENPETS_ODENPETS_1':
      return 'ODENPETS_Pochi'
    case 'ODENPETS_P1_1':
      return 'ODENPETS_Nyanpen'
    case 'Ossan_Paradise_Ossan_Paradise_1':
      return 'OssanParadise_1'
    case 'Ossan_Paradise_Ossan_Paradise_2':
      return 'OssanParadise_2'
    case 'Ossan_Paradise_Ossan_Paradise_3':
      return 'OssanParadise_3'
    case 'Ossan_Paradise_Ossan_Paradise_4':
      return 'OssanParadise_4'
    case 'Ossan_Paradise_Ossan_Paradise_5':
      return 'OssanParadise_5'
    case 'P1_Faireaf_1':
      return 'F2'
    case 'P1_Hiyori_1':
      return 'J8'
    case 'P1_Icelime_1':
      return 'I12'
    case 'P1_Kids_Hero_1':
      return 'H17'
    case 'P1_Layla_1':
      return 'G20'
    case 'P1_P1_1':
      return 'P1_XSoldier'
    case 'P1_SignWitch_1':
      return 'W3'
    case 'Planetman_AstarCats_1':
      return 'planetman_astarcat'
    case 'Planetman_CCT_1':
      return 'planetman_conintown'
    case 'Planetman_Golem_1':
      return 'planetman_golem'
    case 'Planetman_Kids_Hero_1':
      return 'planetman_kidhero'
    case 'Planetman_Ossan_Paradise_1':
      return 'planetman_ossan'
    case 'Planetman_Planetman_1':
      return 'PlanetMan_1'
    case 'Planetman_Unicorn_1':
      return 'planetman_unicorn'
    case 'SignWitch_Ame_chan_1':
      return 'Signwitch_Pisces'
    case 'SignWitch_AstarCats_1':
      return 'Signwitch_GeminiA'
    case 'SignWitch_AstarCats_2':
      return 'Signwitch_GeminiB'
    case 'SignWitch_Faireaf_1':
      return 'Signwitch_Virgilia'
    case 'SignWitch_Hiyori_1':
      return 'Signwitch_Aquarius'
    case 'SignWitch_Layla_1':
      return 'Signwitch_Sagittarius'
    case 'SignWitch_P1_1':
      return 'Signwitch_Leo'
    case 'SignWitch_Planetman_1':
      return 'Signwitch_Libra'
    case 'SignWitch_SignWitch_1':
      return 'SignWitch_Aries'
    case 'SignWitch_Tofu_1':
      return 'Signwitch_Carpicorn'
    case 'SignWitch_Unicorn_1':
      return 'Signwitch_Cancer'
    case 'SignWitch_UPA_1':
      return 'Signwitch_Scorpius'
    case 'SignWitch_Valius_1':
      return 'Signwitch_Taurus'
    case 'Tofu_DEKAUSA_1':
      return 'Tofu_Sainome'
    case 'Tofu_Golem_1':
      return 'Tofu_Konya'
    case 'Tofu_Icelime_1':
      return 'Tofu_Blue-mint'
    case 'Tofu_Planetman_1':
      return 'Tofu_Yaki-tofu'
    case 'Tofu_SignWitch_1':
      return 'Tofu_Neri-yokan'
    case 'Tofu_Tofu_1':
      return 'Tofu_1'
    case 'Tofu_Yamato_1':
      return 'Tofu_Timekeeper'
    case 'Unicorn_AstarCats_1':
      return 'Unicorn_Skywalker'
    case 'Unicorn_CCT_1':
      return 'Unicorn_Hanamiuma'
    case 'Unicorn_ODENPETS_1':
      return 'Unicorn_Soundhorse'
    case 'Unicorn_Planetman_1':
      return 'Unicorn_Burhimu'
    case 'Unicorn_Unicorn_1':
      return 'Unicorn_1'
    case 'Unicorn_UPA_1':
      return 'Unicorn_Kelpie'
    case 'Unicorn_Valius_1':
      return 'Unicorn_Crimson'
    case 'UPA_AstarCats_1':
      return 'UPA[AC]'
    case 'UPA_Golem_1':
      return 'UPA[Gorem]'
    case 'UPA_Kids_Villain_1':
      return 'UPA[Villain]'
    case 'UPA_ODENPETS_1':
      return 'UPA[ODEN]'
    case 'UPA_Ossan_Paradise_1':
      return 'UPA[Ossan]'
    case 'UPA_UPA_1':
      return 'UPA_1'
    case 'UPA_Yamato_1':
      return 'UPA[1912]'
    case 'Valius_CCT_1':
      return 'Valius_Valy'
    case 'Valius_DEKAUSA_1':
      return 'Valius_Braze hopper'
    case 'Valius_Kids_Villain_1':
      return 'Valius_Night-terror'
    case 'Valius_ODENPETS_1':
      return 'Valius_Stargazer'
    case 'Valius_Ossan_Paradise_1':
      return 'Valius_Sky-fang'
    case 'Valius_Unicorn_1':
      return 'Valius_Wolhorn'
    case 'Valius_Valius_1':
      return 'Valius_1'
    case 'Yamato_Ame_chan_1':
      return 'Yamato_dress'
    case 'Yamato_AstarCats_1':
      return 'Yamato_tshirt'
    case 'Yamato_ODENPETS_1':
      return 'Yamato_waiter'
    case 'Yamato_P1_1':
      return 'Yamato_X'
    case 'Yamato_Tofu_1':
      return 'Yamato_white'
    case 'Yamato_UPA_1':
      return 'Yamato_UPA'
    case 'Yamato_Yamato_1':
      return 'Yamato_1'
    default:
      return ''
  }
}
export const converNameChain = (id) => {
  switch (id) {
    case '20197':
      return 'SAND Verse'
    case '29548':
      return 'MCH Verse'
    case '137':
      return 'Polygon Mainnet'
    case '1':
      return 'Ethereum Mainnet'
    case '42161':
      return 'Arbitrum One'
    case '592':
      return 'Astar'
    case 248:
      return 'Oasys'
    case 20197:
      return 'SAND Verse'
    case 29548:
      return 'MCH Verse'
    case 137:
      return 'Polygon Mainnet'
    case 1:
      return 'Ethereum Mainnet'
    case 42161:
      return 'Arbitrum One'
    case 592:
      return 'Astar'
    default:
      return ''
  }
}

export const converNameCollection = (seed) => {
  switch (seed) {
    case 'Faireaf':
      return 'Re.Monster'
    case 'Golem':
      return 'Re.Monster'
    case 'Tofu':
      return 'Re.Monster'
    case 'Unicorn':
      return 'Re.Monster'
    case 'Valius':
      return 'Re.Monster'
    case 'AstarCats':
      return 'Astar Cats'
    case 'SignWitch':
      return 'SignWitch'
    case 'Layla':
      return 'Love Addicted Girls'
    case 'ODENPETS':
      return 'Odenpets'
    case 'UPA':
      return 'UPA'
    case 'Hiyori':
      return 'Wafukugen'
    case 'Yamato':
      return '1912'
    case 'DEKAUSA':
      return 'Allemon'
    case 'CCT':
      return 'Candy Cony Town'
    case 'Icelime':
      return 'Eien'
    case 'Ame_chan':
      return 'Kawaii GIrl'
    case 'Kids_Hero':
      return 'Kids Fight'
    case 'Kids_Villain':
      return 'Kids Fight'
    case 'Sake_Barrel_PlanetMan':
      return 'MetaX'
    case 'Planetman':
      return 'MetaX'
    case 'P1':
      return 'X Soldiers'
    case 'Ossan_Paradise':
      return 'Ossan Paradise'
    default:
      return ''
  }
}

export const converImageCollection = (seed) => {
  switch (seed) {
    case 'Faireaf':
      return 'reMonster'
    case 'Golem':
      return 'reMonster'
    case 'Tofu':
      return 'reMonster'
    case 'Unicorn':
      return 'reMonster'
    case 'Valius':
      return 'reMonster'
    case 'AstarCats':
      return 'astarcats'
    case 'SignWitch':
      return 'astarsignWitch'
    case 'Layla':
      return 'loveaddictedgirls'
    case 'ODENPETS':
      return 'odenpets'
    case 'UPA':
      return 'upa'
    case 'Hiyori':
      return 'wafukugen'
    case 'Yamato':
      return '1912'
    case 'DEKAUSA':
      return 'allemon'
    case 'CCT':
      return 'candyconytown'
    case 'Icelime':
      return 'eien'
    case 'Ame_chan':
      return 'kawaiiGIrlNFT'
    case 'Kids_Hero':
      return 'kidsfight'
    case 'Kids_Villain':
      return 'kidsfight'
    case 'Sake_Barrel_PlanetMan':
      return 'metaX'
    case 'Planetman':
      return 'metaX'
    case 'P1':
      return 'xsoldiers'
    case 'Ossan_Paradise':
      return 'ossanparadise'
    default:
      return ''
  }
}

export const converImageSkill = (id) => {
  switch (id) {
    case 'Ame_chan_Golem_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Ame_chan_Hiyori_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Ame_chan_Icelime_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Ame_chan_Villain_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Ame_chan_Yamato_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Amechan_1_Skill_1':
      return 'Amechan_1_Skill_1'
    case 'Amechan_1_Skill_2':
      return 'Amechan_1_Skill_2'
    case 'Amechan_1_Skill_3':
      return 'Amechan_1_Skill_3'
    case 'Amechan_1_Skill_4':
      return 'Amechan_1_Skill_4'
    case 'Amechan_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Ame_chan_Layla_1_Skill_5':
      return 'Amechan_1_Skill_5'
    case 'Amechan_1_Skill_6':
      return 'Amechan_1_Skill_6'
    case 'AstarCat_1_Skill_1':
      return 'AstarCat_1_Skill_1'
    case 'AstarCat_1_Skill_2':
      return 'AstarCat_1_Skill_2'
    case 'AstarCat_1_Skill_3':
      return 'AstarCat_1_Skill_3'
    case 'AstarCat_1_Skill_4':
      return 'AstarCat_1_Skill_4'
    case 'AstarCat_1_Skill_5':
      return 'AstarCat_1_Skill_5'
    case 'AstarCat_1_Skill_6':
      return 'AstarCat_1_Skill_6'
    case 'CCT_Bot_Skill_1':
      return 'CCT_Bot_Skill_1'
    case 'CCT_Bot_Skill_2':
      return 'CCT_Bot_Skill_2'
    case 'CCT_Bot_Skill_3':
      return 'CCT_Bot_Skill_3'
    case 'CCT_Bot_Skill_4':
      return 'CCT_Bot_Skill_4'
    case 'CCT_Bot_Skill_5':
      return 'CCT_Bot_Skill_5'
    case 'CCT_Bot_Skill_6':
      return 'CCT_Bot_Skill_6'
    case 'CCT_Coni_Skill_1':
      return 'CCT_Coni_Skill_1'
    case 'CCT_Coni_Skill_2':
      return 'CCT_Coni_Skill_2'
    case 'CCT_Coni_Skill_3':
      return 'CCT_Coni_Skill_3'
    case 'CCT_Coni_Skill_4':
      return 'CCT_Coni_Skill_4'
    case 'CCT_Coni_Skill_5':
      return 'CCT_Coni_Skill_5'
    case 'CCT_Coni_Skill_6':
      return 'CCT_Coni_Skill_6'
    case 'CCT_Conic_Skill_1':
      return 'CCT_Conic_Skill_1'
    case 'CCT_Conic_Skill_2':
      return 'CCT_Conic_Skill_2'
    case 'CCT_Conic_Skill_3':
      return 'CCT_Conic_Skill_3'
    case 'CCT_Conic_Skill_4':
      return 'CCT_Conic_Skill_4'
    case 'CCT_Conic_Skill_5':
      return 'CCT_Conic_Skill_5'
    case 'CCT_Conic_Skill_6':
      return 'CCT_Conic_Skill_6'
    case 'CCT_Mous_Skill_1':
      return 'CCT_Mous_Skill_1'
    case 'CCT_Mous_Skill_2':
      return 'CCT_Mous_Skill_2'
    case 'CCT_Mous_Skill_3':
      return 'CCT_Mous_Skill_3'
    case 'CCT_Mous_Skill_4':
      return 'CCT_Mous_Skill_4'
    case 'CCT_Mous_Skill_5':
      return 'CCT_Mous_Skill_5'
    case 'CCT_Mous_Skill_6':
      return 'CCT_Mous_Skill_6'
    case 'Dekausa_1_Skill_1':
      return 'Dekausa_1_Skill_1'
    case 'Dekausa_1_Skill_2':
      return 'Dekausa_1_Skill_2'
    case 'Dekausa_1_Skill_3':
      return 'Dekausa_1_Skill_3'
    case 'Dekausa_1_Skill_4':
      return 'Dekausa_1_Skill_4'
    case 'Dekausa_1_Skill_5':
      return 'Dekausa_1_Skill_5'
    case 'Dekausa_1_Skill_6':
      return 'Dekausa_1_Skill_6'
    case 'Dekausa_TARU-USA_1_Skill_1':
      return 'Dekausa_1_Skill_1'
    case 'Dekausa_TARU-USA_1_Skill_2':
      return 'Dekausa_1_Skill_2'
    case 'Dekausa_TARU-USA_1_Skill_3':
      return 'Dekausa_1_Skill_3'
    case 'Dekausa_TARU-USA_1_Skill_4':
      return 'Dekausa_1_Skill_4'
    case 'Dekausa_TARU-USA_1_Skill_5':
      return 'Dekausa_1_Skill_5'
    case 'Dekausa_TARU-USA_1_Skill_6':
      return 'Dekausa_1_Skill_6'
    case 'Faireaf_1_Skill_1':
      return 'Faireaf_1_Skill_1'
    case 'Faireaf_1_Skill_2':
      return 'Faireaf_1_Skill_2'
    case 'Faireaf_1_Skill_3':
      return 'Faireaf_1_Skill_3'
    case 'Faireaf_1_Skill_4':
      return 'Faireaf_1_Skill_4'
    case 'Faireaf_1_Skill_5':
      return 'Faireaf_1_Skill_5'
    case 'Faireaf_1_Skill_6':
      return 'Faireaf_1_Skill_6'
    case 'Golem_1_Skill_1':
      return 'Golem_1_Skill_1'
    case 'Golem_1_Skill_2':
      return 'Golem_1_Skill_2'
    case 'Golem_1_Skill_3':
      return 'Golem_1_Skill_3'
    case 'Golem_1_Skill_4':
      return 'Golem_1_Skill_4'
    case 'Golem_1_Skill_5':
      return 'Golem_1_Skill_5'
    case 'Golem_1_Skill_6':
      return 'Golem_1_Skill_6'
    case 'Hiyori_1_Skill_1':
      return 'Hiyori_1_Skill_1'
    case 'Hiyori_1_Skill_2':
      return 'Hiyori_1_Skill_2'
    case 'Hiyori_1_Skill_3':
      return 'Hiyori_1_Skill_3'
    case 'Hiyori_1_Skill_4':
      return 'Hiyori_1_Skill_4'
    case 'Hiyori_1_Skill_5':
      return 'Hiyori_1_Skill_5'
    case 'Hiyori_1_Skill_6':
      return 'Hiyori_1_Skill_6'
    case 'Icelime_Eien_Skill_1':
      return 'Icelime_Eien_Skill_1'
    case 'Icelime_Eien_Skill_2':
      return 'Icelime_Eien_Skill_2'
    case 'Icelime_Eien_Skill_3':
      return 'Icelime_Eien_Skill_3'
    case 'Icelime_Eien_Skill_4':
      return 'Icelime_Eien_Skill_4'
    case 'Icelime_Eien_Skill_5':
      return 'Icelime_Eien_Skill_5'
    case 'Icelime_Eien_Skill_6':
      return 'Icelime_Eien_Skill_6'
    case 'Kidsfight_KidsHero_1_Skill_1':
      return 'Kidsfight_KidsHero_1_Skill_1'
    case 'Kidsfight_KidsHero_1_Skill_2':
      return 'Kidsfight_KidsHero_1_Skill_2'
    case 'Kidsfight_KidsHero_1_Skill_3':
      return 'Kidsfight_KidsHero_1_Skill_3'
    case 'Kidsfight_KidsHero_1_Skill_4':
      return 'Kidsfight_KidsHero_1_Skill_4'
    case 'Kidsfight_KidsHero_1_Skill_5':
      return 'Kidsfight_KidsHero_1_Skill_5'
    case 'Kidsfight_KidsHero_1_Skill_6':
      return 'Kidsfight_KidsHero_1_Skill_6'
    case 'Kidsfight_KidsHero_2_Skill_5':
      return 'Kidsfight_KidsHero_2_Skill_5'
    case 'Kidsfight_KidsHero_2_Skill_6':
      return 'Kidsfight_KidsHero_2_Skill_6'
    case 'Kidsfight_KidsHero_3_Skill_5':
      return 'Kidsfight_KidsHero_3_Skill_5'
    case 'Kidsfight_KidsHero_3_Skill_6':
      return 'Kidsfight_KidsHero_3_Skill_6'
    case 'Kidsfight_KidsHero_4_Skill_5':
      return 'Kidsfight_KidsHero_4_Skill_5'
    case 'Kidsfight_KidsHero_4_Skill_6':
      return 'Kidsfight_KidsHero_4_Skill_6'
    case 'Kidsfight_KidsHero_5_Skill_5':
      return 'Kidsfight_KidsHero_5_Skill_5'
    case 'Kidsfight_KidsHero_5_Skill_6':
      return 'Kidsfight_KidsHero_5_Skill_6'
    case 'Kidsfight_KidsVillian_1_Skill_1':
      return 'Kidsfight_KidsVillian_1_Skill_1'
    case 'Kidsfight_KidsVillian_1_Skill_2':
      return 'Kidsfight_KidsVillian_1_Skill_2'
    case 'Kidsfight_KidsVillian_1_Skill_3':
      return 'Kidsfight_KidsVillian_1_Skill_3'
    case 'Kidsfight_KidsVillian_1_Skill_4':
      return 'Kidsfight_KidsVillian_1_Skill_4'
    case 'Kidsfight_KidsVillian_1_Skill_5':
      return 'Kidsfight_KidsVillian_1_Skill_5'
    case 'Kidsfight_KidsVillian_1_Skill_6':
      return 'Kidsfight_KidsVillian_1_Skill_6'
    case 'Kidsfight_KidsVillian_2_Skill_5':
      return 'Kidsfight_KidsVillian_2_Skill_5'
    case 'Kidsfight_KidsVillian_2_Skill_6':
      return 'Kidsfight_KidsVillian_2_Skill_6'
    case 'Kidsfight_KidsVillian_3_Skill_5':
      return 'Kidsfight_KidsVillian_3_Skill_5'
    case 'Kidsfight_KidsVillian_3_Skill_6':
      return 'Kidsfight_KidsVillian_3_Skill_6'
    case 'Kidsfight_KidsVillian_4_Skill_5':
      return 'Kidsfight_KidsVillian_4_Skill_5'
    case 'Kidsfight_KidsVillian_4_Skill_6':
      return 'Kidsfight_KidsVillian_4_Skill_6'
    case 'Kidsfight_KidsVillian_5_Skill_5':
      return 'Kidsfight_KidsVillian_5_Skill_5'
    case 'Kidsfight_KidsVillian_5_Skill_6':
      return 'Kidsfight_KidsVillian_5_Skill_6'
    case 'Layla_1_Skill_1':
      return 'Layla_1_Skill_1'
    case 'Layla_1_Skill_2':
      return 'Layla_1_Skill_2'
    case 'Layla_1_Skill_3':
      return 'Layla_1_Skill_3'
    case 'Layla_1_Skill_4':
      return 'Layla_1_Skill_4'
    case 'Layla_1_Skill_5':
      return 'Layla_1_Skill_5'
    case 'Layla_1_Skill_6':
      return 'Layla_1_Skill_6'
    case 'ODENPETS_Kumatama_Skill_1':
      return 'Kumatama-Skill1'
    case 'ODENPETS_Kumatama_Skill_2':
      return 'Kumatama-Skill2'
    case 'ODENPETS_Kumatama_Skill_3':
      return 'Kumatama-Skill3'
    case 'ODENPETS_Kumatama_Skill_4':
      return 'Kumatama-Skill4'
    case 'ODENPETS_Kumatama_Skill_5':
      return 'Kumatama-Skill5'
    case 'ODENPETS_Kumatama_Skill_6':
      return 'Kumatama-Skill6'
    case 'ODENPETS_Laby_Skill_1':
      return 'Laby-Skill1'
    case 'ODENPETS_Laby_Skill_2':
      return 'Laby-Skill2'
    case 'ODENPETS_Laby_Skill_3':
      return 'Laby-Skill3'
    case 'ODENPETS_Laby_Skill_4':
      return 'Laby-Skill4'
    case 'ODENPETS_Laby_Skill_5':
      return 'Laby-Skill5'
    case 'ODENPETS_Laby_Skill_6':
      return 'Laby-Skill6'
    case 'ODENPETS_Monta_Skill_1':
      return 'Monta_skill_1_scartch'
    case 'ODENPETS_Monta_Skill_2':
      return 'Monta_skill_2_shuriken'
    case 'ODENPETS_Monta_Skill_3':
      return 'Monta_skill_3_Shadow Alter Ego'
    case 'ODENPETS_Monta_Skill_4':
      return 'Monta_skill_4_eat bananas'
    case 'ODENPETS_Monta_Skill_5':
      return 'Monta-Skill5'
    case 'ODENPETS_Monta_Skill_6':
      return 'Monta_skill_6_Monkey Legion'
    case 'ODENPETS_Nyanpen_Skill_1':
      return 'Nyanpen-Skill1'
    case 'ODENPETS_Nyanpen_Skill_2':
      return 'Nyanpen_skill_2_sleep'
    case 'ODENPETS_Nyanpen_Skill_3':
      return 'Nyanpen_skill_3_dance'
    case 'ODENPETS_Nyanpen_Skill_4':
      return 'Nyanpen-Skill4'
    case 'ODENPETS_Nyanpen_Skill_5':
      return 'Nyanpen_skill_5_walking'
    case 'ODENPETS_Nyanpen_Skill_6':
      return 'Nyanpen_skill_5_walking-1'
    case 'ODENPETS_Pochi_Skill_1':
      return 'ODENPETS_Pochi_Skill_1'
    case 'ODENPETS_Pochi_Skill_2':
      return 'ODENPETS_Pochi_Skill_2'
    case 'ODENPETS_Pochi_Skill_3':
      return 'ODENPETS_Pochi_Skill_3'
    case 'ODENPETS_Pochi_Skill_4':
      return 'ODENPETS_Pochi_Skill_4'
    case 'ODENPETS_Pochi_Skill_5':
      return 'ODENPETS_Pochi_Skill_5'
    case 'ODENPETS_Pochi_Skill_6':
      return 'ODENPETS_Pochi_Skill_6'
    case 'OssanParadise_1_Skill_1':
      return 'OssanParadise_1_Skill_1'
    case 'OssanParadise_1_Skill_2':
      return 'OssanParadise_1_Skill_2'
    case 'OssanParadise_1_Skill_3':
      return 'OssanParadise_1_Skill_3'
    case 'OssanParadise_1_Skill_4':
      return 'OssanParadise_1_Skill_4'
    case 'OssanParadise_1_Skill_5':
      return 'OssanParadise_1_Skill_5'
    case 'OssanParadise_1_Skill_6':
      return 'OssanParadise_1_Skill_6'
    case 'OssanParadise_2_Skill_5':
      return 'OssanParadise_2_Skill_5'
    case 'OssanParadise_2_Skill_6':
      return 'OssanParadise_2_Skill_6'
    case 'OssanParadise_3_Skill_5':
      return 'OssanParadise_3_Skill_5'
    case 'OssanParadise_3_Skill_6':
      return 'OssanParadise_3_Skill_6'
    case 'OssanParadise_4_Skill_5':
      return 'OssanParadise_4_Skill_5'
    case 'OssanParadise_4_Skill_6':
      return 'OssanParadise_4_Skill_6'
    case 'OssanParadise_5_Skill_5':
      return 'OssanParadise_5_Skill_5'
    case 'OssanParadise_5_Skill_6':
      return 'OssanParadise_5_Skill_6'
    case 'P1_XSoldier_Skill_1':
      return 'P1_XSoldier_Skill_1'
    case 'P1_XSoldier_Skill_2':
      return 'P1_XSoldier_Skill_2'
    case 'P1_XSoldier_Skill_3':
      return 'P1_XSoldier_Skill_3'
    case 'P1_XSoldier_Skill_4':
      return 'P1_XSoldier_Skill_4'
    case 'P1_XSoldier_Skill_5':
      return 'P1_XSoldier_Skill_5'
    case 'P1_XSoldier_Skill_6':
      return 'P1_XSoldier_Skill_6'
    case 'PlanetMan_1_Skill_1':
      return 'PlanetMan_1_Skill_1'
    case 'PlanetMan_1_Skill_2':
      return 'PlanetMan_1_Skill_2'
    case 'PlanetMan_1_Skill_3':
      return 'PlanetMan_1_Skill_3'
    case 'PlanetMan_1_Skill_4':
      return 'PlanetMan_1_Skill_4'
    case 'PlanetMan_1_Skill_5':
      return 'PlanetMan_1_Skill_5'
    case 'PlanetMan_1_Skill_6':
      return 'PlanetMan_1_Skill_6'
    case 'SignWitch_Aquarius_Skill_3':
      return 'SignWitch_Aquarius_Skill_3'
    case 'SignWitch_Aquarius_Skill_4':
      return 'SignWitch_Aquarius_Skill_4'
    case 'SignWitch_Aquarius_Skill_5':
      return 'SignWitch_Aquarius_Skill_5'
    case 'SignWitch_Aquarius_Skill_6':
      return 'SignWitch_Aquarius_Skill_6'
    case 'SignWitch_Aries_Skill_1':
      return 'SignWitch_Aries_Skill_1'
    case 'SignWitch_Aries_Skill_2':
      return 'SignWitch_Aries_Skill_2'
    case 'SignWitch_Aries_Skill_3':
      return 'SignWitch_Aries_Skill_3'
    case 'SignWitch_Aries_Skill_4':
      return 'SignWitch_Aries_Skill_4'
    case 'SignWitch_Aries_Skill_5':
      return 'SignWitch_Aries_Skill_5'
    case 'SignWitch_Aries_Skill_6':
      return 'SignWitch_Aries_Skill_6'
    case 'SignWitch_Cancer_Skill_3':
      return 'SignWitch_Cancer_Skill_3'
    case 'SignWitch_Cancer_Skill_4':
      return 'SignWitch_Cancer_Skill_4'
    case 'SignWitch_Cancer_Skill_5':
      return 'SignWitch_Cancer_Skill_5'
    case 'SignWitch_Cancer_Skill_6':
      return 'SignWitch_Cancer_Skill_6'
    case 'SignWitch_Carpicorn_Skill_3':
      return 'SignWitch_Carpicorn_Skill_3'
    case 'SignWitch_Carpicorn_Skill_4':
      return 'SignWitch_Carpicorn_Skill_4'
    case 'SignWitch_Carpicorn_Skill_5':
      return 'SignWitch_Carpicorn_Skill_5'
    case 'SignWitch_Carpicorn_Skill_6':
      return 'SignWitch_Carpicorn_Skill_6'
    case 'SignWitch_GeminiA_Skill_3':
      return 'SignWitch_GeminiA_Skill_3'
    case 'SignWitch_GeminiA_Skill_4':
      return 'SignWitch_GeminiA_Skill_4'
    case 'SignWitch_GeminiA_Skill_5':
      return 'SignWitch_GeminiA_Skill_5'
    case 'SignWitch_GeminiA_Skill_6':
      return 'SignWitch_GeminiA_Skill_6'
    case 'SignWitch_GeminiB_Skill_3':
      return 'SignWitch_GeminiB_Skill_3'
    case 'SignWitchs_GeminiB_Skill_4':
      return 'SignWitch_GeminiB_Skill_4'
    case 'SignWitch_GeminiB_Skill_4':
      return 'SignWitch_GeminiB_Skill_4'
    case 'SignWitch_GeminiB_Skill_5':
      return 'SignWitch_GeminiB_Skill_5'
    case 'SignWitch_GeminiB_Skill_6':
      return 'SignWitch_GeminiB_Skill_6'
    case 'SignWitch_Leo_Skill_3':
      return 'SignWitch_Leo_Skill_3'
    case 'SignWitchs_Leo_Skill_4':
      return 'SignWitch_Leo_Skill_4'
    case 'SignWitch_Leo_Skill_4':
      return 'SignWitch_Leo_Skill_4'
    case 'SignWitch_Leo_Skill_5':
      return 'SignWitch_Leo_Skill_5'
    case 'SignWitch_Leo_Skill_6':
      return 'SignWitch_Leo_Skill_6'
    case 'SignWitch_Libra_Skill_3':
      return 'SignWitch_Libra_Skill_3'
    case 'SignWitchs_Libra_Skill_4':
      return 'SignWitch_Libra_Skill_4'
    case 'SignWitch_Libra_Skill_4':
      return 'SignWitch_Libra_Skill_4'
    case 'SignWitch_Libra_Skill_5':
      return 'SignWitch_Libra_Skill_5'
    case 'SignWitch_Libra_Skill_6':
      return 'SignWitch_Libra_Skill_6'
    case 'SignWitch_Pisces_Skill_3':
      return 'SignWitch_Pisces_Skill_3'
    case 'SignWitchs_Pisces_Skill_4':
      return 'SignWitch_Pisces_Skill_4'
    case 'SignWitch_Pisces_Skill_4':
      return 'SignWitch_Pisces_Skill_4'
    case 'SignWitch_Pisces_Skill_5':
      return 'SignWitch_Pisces_Skill_5'
    case 'SignWitch_Pisces_Skill_6':
      return 'SignWitch_Pisces_Skill_6'
    case 'SignWitch_Sagittarius_Skill_3':
      return 'SignWitch_Sagittarius_Skill_3'
    case 'SignWitchs_Sagittarius_Skill_4':
      return 'SignWitch_Sagittarius_Skill_4'
    case 'SignWitch_Sagittarius_Skill_4':
      return 'SignWitch_Sagittarius_Skill_4'
    case 'SignWitch_Sagittarius_Skill_5':
      return 'SignWitch_Sagittarius_Skill_5'
    case 'SignWitch_Sagittarius_Skill_6':
      return 'SignWitch_Sagittarius_Skill_6'
    case 'SignWitch_Scorpius_Skill_3':
      return 'SignWitch_Scorpius_Skill_3'
    case 'SignWitchs_Scorpius_Skill_4':
      return 'SignWitch_Scorpius_Skill_4'
    case 'SignWitch_Scorpius_Skill_4':
      return 'SignWitch_Scorpius_Skill_4'
    case 'SignWitch_Scorpius_Skill_5':
      return 'SignWitch_Scorpius_Skill_5'
    case 'SignWitch_Scorpius_Skill_6':
      return 'SignWitch_Scorpius_Skill_6'
    case 'SignWitch_Taurus_Skill_3':
      return 'SignWitch_Taurus_Skill_3'
    case 'SignWitchs_Taurus_Skill_4':
      return 'SignWitch_Taurus_Skill_4'
    case 'SignWitch_Taurus_Skill_4':
      return 'SignWitch_Taurus_Skill_4'
    case 'SignWitch_Taurus_Skill_5':
      return 'SignWitch_Taurus_Skill_5'
    case 'SignWitch_Taurus_Skill_6':
      return 'SignWitch_Taurus_Skill_6'
    case 'SignWitch_Virgilia_Skill_3':
      return 'SignWitch_Virgilia_Skill_3'
    case 'SignWitchs_Virgilia_Skill_4':
      return 'SignWitch_Virgilia_Skill_4'
    case 'SignWitch_Virgilia_Skill_4':
      return 'SignWitch_Virgilia_Skill_4'
    case 'SignWitch_Virgilia_Skill_5':
      return 'SignWitch_Virgilia_Skill_5'
    case 'SignWitch_Virgilia_Skill_6':
      return 'SignWitch_Virgilia_Skill_6'
    case 'Tofu_1_Skill_1':
      return 'Tofu_1_Skill_1'
    case 'Tofu_1_Skill_2':
      return 'Tofu_1_Skill_2'
    case 'Tofu_1_Skill_3':
      return 'Tofu_1_Skill_3'
    case 'Tofu_1_Skill_4':
      return 'Tofu_1_Skill_4'
    case 'Tofu_1_Skill_5':
      return 'Tofu_1_Skill_5'
    case 'Tofu_1_Skill_6':
      return 'Tofu_1_Skill_6'
    case 'Unicorn_1_Skill_1':
      return 'Unicorn_1_Skill_1'
    case 'Unicorn_1_Skill_2':
      return 'Unicorn_1_Skill_2'
    case 'Unicorn_1_Skill_3':
      return 'Unicorn_1_Skill_3'
    case 'Unicorn_1_Skill_4':
      return 'Unicorn_1_Skill_4'
    case 'Unicorn_1_Skill_5':
      return 'Unicorn_1_Skill_5'
    case 'Unicorn_1_Skill_6':
      return 'Unicorn_1_Skill_6'
    case 'UPA_1_Skill_1':
      return 'UPA_1_Skill_1'
    case 'UPA_1_Skill_2':
      return 'UPA_1_Skill_2'
    case 'UPA_1_Skill_3':
      return 'UPA_1_Skill_3'
    case 'UPA_1_Skill_4':
      return 'UPA_1_Skill_4'
    case 'UPA_1_Skill_5':
      return 'UPA_1_Skill_5'
    case 'UPA_1_Skill_6':
      return 'UPA_1_Skill_6'
    case 'Valius_1_Skill_1':
      return 'Valius_1_Skill_1'
    case 'Valius_1_Skill_2':
      return 'Valius_1_Skill_2'
    case 'Valius_1_Skill_3':
      return 'Valius_1_Skill_3'
    case 'Valius_1_Skill_4':
      return 'Valius_1_Skill_4'
    case 'Valius_1_Skill_5':
      return 'Valius_1_Skill_5'
    case 'Valius_1_Skill_6':
      return 'Valius_1_Skill_6'
    case 'Yamato_1_Skill_1':
      return 'Yamato_1_Skill_1'
    case 'Yamato_1_Skill_2':
      return 'Yamato_1_Skill_2'
    case 'Yamato_1_Skill_3':
      return 'Yamato_1_Skill_3'
    case 'Yamato_1_Skill_4':
      return 'Yamato_1_Skill_4'
    case 'Yamato_1_Skill_5':
      return 'Yamato_1_Skill_5'
    case 'Yamato_1_Skill_6':
      return 'Yamato_1_Skill_6'
    default:
      return ''
  }
}
export const convertImageMonsterOther = (image) => {
  switch (image) {
    case 'Ame_chan_Ame_chan_1':
      return 'Amechan_1_Hash'
    case 'Ame_chan_Golem_1':
      return 'Amechan_Powered_Hash'
    case 'Ame_chan_Hiyori_1':
      return 'Amechan_Wafuku_Hash'
    case 'Ame_chan_Icelime_1':
      return 'Amechan_Summer_Hash'
    case 'Ame_chan_Kids_Villain_1':
      return 'Amechan_Villain_Hash'
    case 'Ame_chan_Layla_1':
      return 'Amechan_Imp_Hash'
    case 'Ame_chan_Yamato_1':
      return 'Amechan_School_Hash'
    case 'AstarCats_AstarCats_1':
      return 'AstarCats_1_Hash'
    case 'AstarCats_Faireaf_1':
      return 'AstarCats_FairyCats_Hash'
    case 'AstarCats_Hiyori_1':
      return 'AstarCats_WafukuCats_Hash'
    case 'AstarCats_Kids_Villain_1':
      return 'AstarCats_VillainCats_Hash'
    case 'AstarCats_Ossan_Paradise_1':
      return 'AstarCats_MaskCats_Hash'
    case 'AstarCats_SignWitch_1':
      return 'AstarCats_WitchCats_Hash'
    case 'AstarCats_Tofu_1':
      return 'AstarCats_TofuCats_Hash'
    case 'CCT_CCT_1':
      return 'CCT_Coni_Hash'
    case 'CCT_CCT_2':
      return 'CCT_Mous_Hash'
    case 'CCT_CCT_3':
      return 'CCT_BOT_Hash'
    case 'CCT_CCT_4':
      return 'CCT_Conic_Hash'
    case 'DEKAUSA_CCT_1':
      return 'DEKAUSA_DEKAUCONI_Hash'
    case 'DEKAUSA_DEKAUSA_1':
      return 'DEKAUSA_1_Hash'
    case 'DEKAUSA_Golem_1':
      return 'DEKAUSA_GOLIATH_Hash'
    case 'DEKAUSA_ODENPETS_1':
      return 'DEKAUSA_DEKALABY_Hash'
    case 'DEKAUSA_Planetman_1':
      return 'DEKAUSA_TARU-USA_Hash'
    case 'DEKAUSA_Tofu_1':
      return 'DEKAUSA_SOY_Hash'
    case 'DEKAUSA_Yamato_1':
      return 'DEKAUSA_BANCHO_Hash'
    case 'Faireaf_Ame_chan_1':
      return 'Faireaf_Cantis_Hash'
    case 'Faireaf_Faireaf_1':
      return 'Faireaf_1_Hash'
    case 'Faireaf_Layla_1':
      return 'Faireaf_Lilim_Hash'
    case 'Faireaf_P1_1':
      return 'Faireaf_Caliy_Hash'
    case 'Faireaf_SignWitch_1':
      return 'Faireaf_Aether_Hash'
    case 'Faireaf_Tofu_1':
      return 'Faireaf_Whisper_Hash'
    case 'Faireaf_Valius_1':
      return 'Faireaf_Wolfair_Hash'
    case 'Golem_DEKAUSA_1':
      return 'Golem_Rabilen_Hash'
    case 'Golem_Golem_1':
      return 'Golem_1_Hash'
    case 'Golem_Kids_Hero_1':
      return 'Golem_Patrolem_Hash'
    case 'Golem_Kids_Villain_1':
      return 'Golem_Pazuzu_Hash'
    case 'Golem_Ossan_Paradise_1':
      return 'Golem_Quackle_Hash'
    case 'Golem_Planetman_1':
      return 'Golem_Wooden_Hash'
    case 'Golem_UPA_1':
      return 'Golem_Looper_Hash'
    case 'Hiyori_Ame_chan_1':
      return 'Hiyori_Yui_Hash'
    case 'Hiyori_Faireaf_1':
      return 'Hiyori_Mei_Hash'
    case 'Hiyori_Hiyori_1':
      return 'Hiyori_1_Hash'
    case 'Hiyori_Icelime_1':
      return 'Hiyori_Nanami_Hash'
    case 'Hiyori_Layla_1':
      return 'Hiyori_Ayano_Hash'
    case 'Hiyori_Unicorn_1':
      return 'Hiyori_Orika_Hash'
    case 'Hiyori_Valius_1':
      return 'Hiyori_Akane_Hash'
    case 'Icelime_CCT_1':
      return 'Icelime_Caramel-fromage_Hash'
    case 'Icelime_DEKAUSA_1':
      return 'Icelime_Bunny-bunny_Hash'
    case 'Icelime_Icelime_1':
      return 'Icelime_1_Hash'
    case 'Icelime_Kids_Hero_1':
      return 'Icelime_Star-berry_Hash'
    case 'Icelime_Unicorn_1':
      return 'Icelime_Vanilla_Hash'
    case 'Icelime_UPA_1':
      return 'Icelime_Emerald-sufer_Hash'
    case 'Icelime_Yamato_1':
      return 'Icelime_Ogaki-blue_Hash'
    case 'Kids_Hero_Kids_Hero_1':
      return 'KidsHero_1_Hash'
    case 'Kids_Hero_Kids_Hero_2':
      return 'KidsHero_2_Hash'
    case 'Kids_Hero_Kids_Hero_3':
      return 'KidsHero_3_Hash'
    case 'Kids_Hero_Kids_Hero_4':
      return 'KidsHero_4_Hash'
    case 'Kids_Hero_Kids_Hero_5':
      return 'KidsHero_5_Hash'
    case 'Kids_Villain_Kids_Villain_1':
      return 'KidsVillain_1_Hash'
    case 'Kids_Villain_Kids_Villain_2':
      return 'KidsVillain_2_Hash'
    case 'Kids_Villain_Kids_Villain_3':
      return 'KidsVillain_3_Hash'
    case 'Kids_Villain_Kids_Villain_4':
      return 'KidsVillain_4_Hash'
    case 'Kids_Villain_Kids_Villain_5':
      return 'KidsVillain_5_Hash'
    case 'Layla_Faireaf_1':
      return 'Layla_Bella_Hash'
    case 'Layla_Hiyori_1':
      return 'Layla_Matoi_Hash'
    case 'Layla_Icelime_1':
      return 'Layla_Sora_Hash'
    case 'Layla_Layla_1':
      return 'Layla_1_Hash'
    case 'Layla_P1_1':
      return 'Layla_Eve_Hash'
    case 'Layla_SignWitch_1':
      return 'Layla_Olivia_Hash'
    case 'Layla_Valius_1':
      return 'Layla_Luna_Hash'
    case 'ODENPETS_Ame_chan_1':
      return 'ODENPETS_Kumatama_Hash'
    case 'ODENPETS_DEKAUSA_1':
      return 'ODENPETS_Laby_Hash'
    case 'ODENPETS_Kids_Hero_1':
      return 'ODENPETS_Monta_Hash'
    case 'ODENPETS_ODENPETS_1':
      return 'ODENPETS_1_Hash'
    case 'ODENPETS_P1_1':
      return 'ODENPETS_Nyanpen_Hash'
    case 'Ossan_Paradise_Ossan_Paradise_1':
      return 'OssanParadise_1_Hash'
    case 'Ossan_Paradise_Ossan_Paradise_2':
      return 'OssanParadise_2_Hash'
    case 'Ossan_Paradise_Ossan_Paradise_3':
      return 'OssanParadise_3_Hash'
    case 'Ossan_Paradise_Ossan_Paradise_4':
      return 'OssanParadise_4_Hash'
    case 'Ossan_Paradise_Ossan_Paradise_5':
      return 'OssanParadise_5_Hash'
    case 'P1_Faireaf_1':
      return 'P1_F2_Hash'
    case 'P1_Hiyori_1':
      return 'P1_J8_Hash'
    case 'P1_Icelime_1':
      return 'P1_I12_Hash'
    case 'P1_Kids_Hero_1':
      return 'P1_H17_Hash'
    case 'P1_Layla_1':
      return 'P1_G20_Hash'
    case 'P1_P1_1':
      return 'P1_1_Hash'
    case 'P1_SignWitch_1':
      return 'P1_W3_Hash'
    case 'Planetman_AstarCats_1':
      return 'PlanetMan_Matatabi-Barred_Hash'
    case 'Planetman_CCT_1':
      return 'PlanetMan_Sake-Pottery_Hash'
    case 'Planetman_Golem_1':
      return 'PlanetMan_Sake-Metal_Hash'
    case 'Planetman_Kids_Hero_1':
      return 'PlanetMan_Kids-Barrel_Hash'
    case 'Planetman_Ossan_Paradise_1':
      return 'PlanetMan_Sake-Cup_Hash'
    case 'Planetman_Planetman_1':
      return 'PlanetMan_1_Hash'
    case 'Planetman_Unicorn_1':
      return 'PlanetMan_Sake-Shiraki_Hash'
    case 'SignWitch_Ame_chan_1':
      return 'SignWitch_Pisces_Hash'
    case 'SignWitch_AstarCats_1':
      return 'SignWitch_Gem_Hash'
    case 'SignWitch_AstarCats_2':
      return 'SignWitch_Meg_Hash'
    case 'SignWitch_Faireaf_1':
      return 'SignWitch_Virgilia_Hash'
    case 'SignWitch_Hiyori_1':
      return 'SignWitch_Aquarius_Hash'
    case 'SignWitch_Layla_1':
      return 'SignWitch_Sagittarius_Hash'
    case 'SignWitch_P1_1':
      return 'SignWitch_Leo_Hash'
    case 'SignWitch_Planetman_1':
      return 'SignWitch_Libra_Hash'
    case 'SignWitch_SignWitch_1':
      return 'SignWitch_Aries_Hash'
    case 'SignWitch_Tofu_1':
      return 'SignWitch_Capricorn_Hash'
    case 'SignWitch_Unicorn_1':
      return 'SignWitch_Cancer_Hash'
    case 'SignWitch_UPA_1':
      return 'SignWitch_Scorpius_Hash'
    case 'SignWitch_Valius_1':
      return 'SignWitch_Taurus_Hash'
    case 'Tofu_DEKAUSA_1':
      return 'Tofu_Sainome_Hash'
    case 'Tofu_Golem_1':
      return 'Tofu_Koya_Hash'
    case 'Tofu_Icelime_1':
      return 'Tofu_Blue-mint_Hash'
    case 'Tofu_Planetman_1':
      return 'Tofu_Yaki-tofu_Hash'
    case 'Tofu_SignWitch_1':
      return 'Tofu_Neri-yokan_Hash'
    case 'Tofu_Tofu_1':
      return 'Tofu_1_Hash'
    case 'Tofu_Yamato_1':
      return 'Tofu_Timekeeper_Hash'
    case 'Unicorn_AstarCats_1':
      return 'Unicorn_Skywalker_Hash'
    case 'Unicorn_CCT_1':
      return 'Unicorn_Burhimu_Hash'
    case 'Unicorn_ODENPETS_1':
      return 'Unicorn_Soundhorse_Hash'
    case 'Unicorn_Planetman_1':
      return 'Unicorn_Hanamiuma_Hash'
    case 'Unicorn_Unicorn_1':
      return 'Unicorn_1_Hash'
    case 'Unicorn_UPA_1':
      return 'Unicorn_Kelpie_Hash'
    case 'Unicorn_Valius_1':
      return 'Unicorn_Crimson_Hash'
    case 'UPA_AstarCats_1':
      return 'UPA_AC_Hash'
    case 'UPA_Golem_1':
      return 'UPA_Golem_Hash'
    case 'UPA_Kids_Villain_1':
      return 'UPA_Villain_Hash'
    case 'UPA_ODENPETS_1':
      return 'UPA_ODEN_Hash'
    case 'UPA_Ossan_Paradise_1':
      return 'UPA_Ossan_Hash'
    case 'UPA_UPA_1':
      return 'UPA_1_Hash'
    case 'UPA_Yamato_1':
      return 'UPA_1912_Hash'
    case 'Valius_CCT_1':
      return 'Valius_Valy_Hash'
    case 'Valius_DEKAUSA_1':
      return 'Valius_Brazehopper_Hash'
    case 'Valius_Kids_Villain_1':
      return 'Valius_Night-terror_Hash'
    case 'Valius_ODENPETS_1':
      return 'Valius_Stargazer_Hash'
    case 'Valius_Ossan_Paradise_1':
      return 'Valius_Sky-fang_Hash'
    case 'Valius_Unicorn_1':
      return 'Valius_Wolhorn_Hash'
    case 'Valius_Valius_1':
      return 'Valius_1_Hash'
    case 'Yamato_Ame_chan_1':
      return 'Yamato_Dress_Hash'
    case 'Yamato_AstarCats_1':
      return 'Yamato_Tshirt_Hash'
    case 'Yamato_ODENPETS_1':
      return 'Yamato_Waiter_Hash'
    case 'Yamato_P1_1':
      return 'Yamato_X_Hash'
    case 'Yamato_Tofu_1':
      return 'Yamato_White_Hash'
    case 'Yamato_UPA_1':
      return 'Yamato_UPA_Hash'
    case 'Yamato_Yamato_1':
      return 'Yamato_1_Hash'
    default:
      return ''
  }
}

export const getColorRankSkill = (skill) => {
  const colors = {
    F: '#8C8C8C',
    E: '#52C41A',
    D: '#4AACD1',
    C: '#2F54EB',
    B: '#722ED1',
    A: '#D064A5',
    S: '#F4AF3E',
  }
  return { color: colors[skill] || '' }
}

export const getCollectionMonster = (mintType) => {
  switch (mintType) {
    case 0:
      return 'NFTs'
    case 1:
      return 'Collaboration NFT'
    case 2:
      return 'Free'
    case 3:
      return 'Genesis Hash'
    case 4:
      return 'General Hash'
    case 5:
      return 'Hash Chip NFT'
    case 6:
      return 'Items Hash'
    case 7:
      return 'Fusion Regeneration (Genesis x Genesis)'
    case 8:
      return 'Fusion Regeneration (Genesis x General)'
    case 9:
      return 'Fusion Regeneration (General x General)'
    case 10:
      return 'Fusion'
    case 11:
      return 'Random Regeneration'

    default:
      return ''
  }
}
export const extractConvertMonsterSeed = (monster_script_id) => {
  if (!monster_script_id) return { mainSeed: '', subSeed: '' }

  const specialTerms = [
    'Ossan_Paradise',
    'Kids_Villain',
    'Kids_Hero',
    'Ame_chan',
  ]

  const parts = monster_script_id.split('_')
  const lastPart = parts.pop()

  let subSeed = ''
  let mainSeed = ''
  for (let i = parts.length; i > 0; i--) {
    const possiblePart2 = parts.slice(i - 1).join('_')
    if (specialTerms.includes(possiblePart2)) {
      subSeed = possiblePart2
      mainSeed = parts.slice(0, i - 1).join('_')
      break
    }
  }

  if (!subSeed) {
    subSeed = parts.pop()
    mainSeed = parts.join('_')
  }

  return { mainSeed, subSeed, lastPart }
}
export const convertImageMonsterSeed = (image) => {
  switch (image) {
    case 'Ame_chan_Ame_chan_1':
      return 'Amechan_1_InGame'
    case 'Ame_chan_Golem_1':
      return 'Amechan [Powered]_InGame'
    case 'Ame_chan_Hiyori_1':
      return 'Amechan [Wafuku]_InGame'
    case 'Ame_chan_Icelime_1':
      return 'Amechan [Summer]_InGame'
    case 'Ame_chan_Kids_Villain_1':
      return 'Amechan [Villain]_InGame'
    case 'Ame_chan_Layla_1':
      return 'Amechan [Imp]_InGame'
    case 'Ame_chan_Yamato_1':
      return 'Amechan [School]_InGame'
    case 'AstarCats_AstarCats_1':
      return 'AstarCat_1_InGame'
    case 'AstarCats_Faireaf_1':
      return 'AstarCat_FairyCat_InGame'
    case 'AstarCats_Hiyori_1':
      return 'AstarCat_WafukuCat_InGame'
    case 'AstarCats_Kids_Villain_1':
      return 'AstarCat_VillainCat_InGame'
    case 'AstarCats_Ossan_Paradise_1':
      return 'AstarCat_MaskCat_InGame'
    case 'AstarCats_SignWitch_1':
      return 'AstarCat_WitchCat_InGame'
    case 'AstarCats_Tofu_1':
      return 'AstarCat_TofuCat_InGame'
    case 'CCT_CCT_1':
      return 'CCT_Coni_InGame'
    case 'CCT_CCT_2':
      return 'CCT_Mous_InGame'
    case 'CCT_CCT_3':
      return 'CCT_Bot_InGame'
    case 'CCT_CCT_4':
      return 'CCT_Conic_InGame'
    case 'DEKAUSA_CCT_1':
      return 'Dekausa_DEKACONI_InGame'
    case 'DEKAUSA_DEKAUSA_1':
      return 'Dekausa_1_InGame'
    case 'DEKAUSA_Golem_1':
      return 'Dekausa_GOLIATH_InGame'
    case 'DEKAUSA_ODENPETS_1':
      return 'Dekausa_DEKALABY_InGame'
    case 'DEKAUSA_Planetman_1':
      return 'Dekausa_TARU-USA_InGame'
    case 'DEKAUSA_Tofu_1':
      return 'Dekausa_SOY_InGame'
    case 'DEKAUSA_Yamato_1':
      return 'Dekausa_BANCHO_InGame'
    case 'Faireaf_Ame_chan_1':
      return 'Faireaf_Cantis_InGame'
    case 'Faireaf_Faireaf_1':
      return 'Faireaf_1_InGame'
    case 'Faireaf_Layla_1':
      return 'Faireaf_Lilim_InGame'
    case 'Faireaf_P1_1':
      return 'Faireaf_Caliy_InGame'
    case 'Faireaf_SignWitch_1':
      return 'Faireaf_Aether_InGame'
    case 'Faireaf_Tofu_1':
      return 'Faireaf_Whisper_InGame'
    case 'Faireaf_Valius_1':
      return 'Faireaf_Wolfair_InGame'
    case 'Golem_DEKAUSA_1':
      return 'Rabilen_1_InGame'
    case 'Golem_Golem_1':
      return 'Golem_1_InGame'
    case 'Golem_Kids_Hero_1':
      return 'Patrolem_1_InGame'
    case 'Golem_Kids_Villain_1':
      return 'Pazuzu_1_InGame'
    case 'Golem_Ossan_Paradise_1':
      return 'Quackle_1_InGame'
    case 'Golem_Planetman_1':
      return 'Wooden_1_InGame'
    case 'Golem_UPA_1':
      return 'Looper_1_InGame'
    case 'Hiyori_Ame_chan_1':
      return 'Hiyori_Nanami_InGame'
    case 'Hiyori_Faireaf_1':
      return 'Hiyori_Mei_InGame'
    case 'Hiyori_Hiyori_1':
      return 'Hiyori_1_InGame'
    case 'Hiyori_Icelime_1':
      return 'Hiyori_Yui_InGame'
    case 'Hiyori_Layla_1':
      return 'Hiyori_Ayano_InGame'
    case 'Hiyori_Unicorn_1':
      return 'Hiyori_Orika_InGame'
    case 'Hiyori_Valius_1':
      return 'Hiyori_Akane_InGame'
    case 'Icelime_CCT_1':
      return 'icelime_conintown_InGame'
    case 'Icelime_DEKAUSA_1':
      return 'icelime_dekausa_InGame'
    case 'Icelime_Icelime_1':
      return 'IceLime_Eien_InGame'
    case 'Icelime_Kids_Hero_1':
      return 'icelime_kidhero_InGame'
    case 'Icelime_Unicorn_1':
      return 'icelime_unicorn_InGame'
    case 'Icelime_UPA_1':
      return 'icelime_UPA_InGame'
    case 'Icelime_Yamato_1':
      return 'icelime_yamato_InGame'
    case 'Kids_Hero_Kids_Hero_1':
      return 'Kidsfight_KidsHero_1_InGame'
    case 'Kids_Hero_Kids_Hero_2':
      return 'Kidsfight_KidsHero_2_InGame'
    case 'Kids_Hero_Kids_Hero_3':
      return 'Kidsfight_KidsHero_3_InGame'
    case 'Kids_Hero_Kids_Hero_4':
      return 'Kidsfight_KidsHero_4_InGame'
    case 'Kids_Hero_Kids_Hero_5':
      return 'Kidsfight_KidsHero_5_InGame'
    case 'Kids_Villain_Kids_Villain_1':
      return 'Kidsfight_KidsVillian_1_InGame'
    case 'Kids_Villain_Kids_Villain_2':
      return 'Kidsfight_KidsVillian_2_InGame'
    case 'Kids_Villain_Kids_Villain_3':
      return 'Kidsfight_KidsVillian_3_InGame'
    case 'Kids_Villain_Kids_Villain_4':
      return 'Kidsfight_KidsVillian_4_InGame'
    case 'Kids_Villain_Kids_Villain_5':
      return 'Kidsfight_KidsVillian_5_InGame'
    case 'Layla_Faireaf_1':
      return 'Layla_Bella_InGame'
    case 'Layla_Hiyori_1':
      return 'Layla_Matoi_InGame'
    case 'Layla_Icelime_1':
      return 'Layla_Sora_InGame'
    case 'Layla_Layla_1':
      return 'Layla_1_InGame'
    case 'Layla_P1_1':
      return 'Layla_Eve_InGame'
    case 'Layla_SignWitch_1':
      return 'Layla_Olivia_InGame'
    case 'Layla_Valius_1':
      return 'Layla_Luna_InGame'
    case 'ODENPETS_Ame_chan_1':
      return 'ODENPETS_Kumatama_InGame'
    case 'ODENPETS_DEKAUSA_1':
      return 'ODENPETS_Laby_InGame'
    case 'ODENPETS_Kids_Hero_1':
      return 'ODENPETS_Monta_InGame'
    case 'ODENPETS_ODENPETS_1':
      return 'ODENPETS_Pochi_InGame'
    case 'ODENPETS_P1_1':
      return 'ODENPETS_Nyanpen_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_1':
      return 'OssanParadise_1_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_2':
      return 'OssanParadise_2_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_3':
      return 'OssanParadise_3_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_4':
      return 'OssanParadise_4_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_5':
      return 'OssanParadise_5_InGame'
    case 'P1_Faireaf_1':
      return 'F2_InGame'
    case 'P1_Hiyori_1':
      return 'J8_InGame'
    case 'P1_Icelime_1':
      return 'I12_InGame'
    case 'P1_Kids_Hero_1':
      return 'H17_InGame'
    case 'P1_Layla_1':
      return 'G20_InGame'
    case 'P1_P1_1':
      return 'P1_XSoldier_InGame'
    case 'P1_SignWitch_1':
      return 'W3_InGame'
    case 'Planetman_AstarCats_1':
      return 'planetman_astarcat_InGame'
    case 'Planetman_CCT_1':
      return 'planetman_conintown_InGame'
    case 'Planetman_Golem_1':
      return 'planetman_golem_InGame'
    case 'Planetman_Kids_Hero_1':
      return 'planetman_kidhero_InGame'
    case 'Planetman_Ossan_Paradise_1':
      return 'planetman_ossan_InGame'
    case 'Planetman_Planetman_1':
      return 'PlanetMan_1_InGame'
    case 'Planetman_Unicorn_1':
      return 'planetman_unicorn_InGame'
    case 'SignWitch_Ame_chan_1':
      return 'Signwitch_Pisces_InGame'
    case 'SignWitch_AstarCats_1':
      return 'Signwitch_GeminiA_InGame'
    case 'SignWitch_AstarCats_2':
      return 'Signwitch_GeminiB_InGame'
    case 'SignWitch_Faireaf_1':
      return 'Signwitch_Virgilia_InGame'
    case 'SignWitch_Hiyori_1':
      return 'Signwitch_Aquarius_InGame'
    case 'SignWitch_Layla_1':
      return 'Signwitch_Sagittarius_InGame'
    case 'SignWitch_P1_1':
      return 'Signwitch_Leo_InGame'
    case 'SignWitch_Planetman_1':
      return 'Signwitch_Libra_InGame'
    case 'SignWitch_SignWitch_1':
      return 'SignWitch_Aries_InGame'
    case 'SignWitch_Tofu_1':
      return 'SignWitch_Capricorn_InGame'
    case 'SignWitch_Unicorn_1':
      return 'Signwitch_Cancer_InGame'
    case 'SignWitch_UPA_1':
      return 'Signwitch_Scorpius_InGame'
    case 'SignWitch_Valius_1':
      return 'Signwitch_Taurus_InGame'
    case 'Tofu_DEKAUSA_1':
      return 'Tofu_Sainome_InGame'
    case 'Tofu_Golem_1':
      return 'Tofu_Konya_InGame'
    case 'Tofu_Icelime_1':
      return 'Tofu_Blue-mint_InGame'
    case 'Tofu_Planetman_1':
      return 'Tofu_Yaki-tofu_InGame'
    case 'Tofu_SignWitch_1':
      return 'Tofu_Neri-yokan_InGame'
    case 'Tofu_Tofu_1':
      return 'Tofu_1_InGame'
    case 'Tofu_Yamato_1':
      return 'Tofu_Timekeeper_InGame'
    case 'Unicorn_AstarCats_1':
      return 'Unicorn_Skywalker_InGame'
    case 'Unicorn_CCT_1':
      return 'Unicorn_Hanamiuma_InGame'
    case 'Unicorn_ODENPETS_1':
      return 'Unicorn_Soundhorse_InGame'
    case 'Unicorn_Planetman_1':
      return 'Unicorn_Burhimu_InGame'
    case 'Unicorn_Unicorn_1':
      return 'Unicorn_1_InGame'
    case 'Unicorn_UPA_1':
      return 'Unicorn_Kelpie_InGame'
    case 'Unicorn_Valius_1':
      return 'Unicorn_Crimson_InGame'
    case 'UPA_AstarCats_1':
      return 'UPA[AC]_InGame'
    case 'UPA_Golem_1':
      return 'UPA[Gorem]_InGame'
    case 'UPA_Kids_Villain_1':
      return 'UPA[Villain]_InGame'
    case 'UPA_ODENPETS_1':
      return 'UPA[ODEN]_InGame'
    case 'UPA_Ossan_Paradise_1':
      return 'UPA[Ossan]_InGame'
    case 'UPA_UPA_1':
      return 'UPA_1_InGame'
    case 'UPA_Yamato_1':
      return 'UPA[1912]_InGame'
    case 'Valius_CCT_1':
      return 'Valy_InGame'
    case 'Valius_DEKAUSA_1':
      return 'Braze hopper_InGame'
    case 'Valius_Kids_Villain_1':
      return 'Night-terror_InGame'
    case 'Valius_ODENPETS_1':
      return 'Stargazer_InGame'
    case 'Valius_Ossan_Paradise_1':
      return 'Sky-fang_InGame'
    case 'Valius_Unicorn_1':
      return 'Wolhorn_InGame'
    case 'Valius_Valius_1':
      return 'Valius_1_InGame'
    case 'Yamato_Ame_chan_1':
      return 'yamato_dress_InGame'
    case 'Yamato_AstarCats_1':
      return 'yamato_tshirt_InGame'
    case 'Yamato_ODENPETS_1':
      return 'yamato_waiter_InGame'
    case 'Yamato_P1_1':
      return 'yamato_X_InGame'
    case 'Yamato_Tofu_1':
      return 'yamato_white_InGame'
    case 'Yamato_UPA_1':
      return 'yamato_UPA_InGame'
    case 'Yamato_Yamato_1':
      return 'Yamato_1_InGame'
    default:
      return 'Signwitch_Carpicorn_InGame'
  }
}
export const convertNameMonsterFusion = (name) => {
  switch (name) {
    case 'Faireaf_Faireaf_1':
      return 'Faireaf'
    case 'Faireaf_Tofu_1':
      return 'Whisper'
    case 'Faireaf_Valius_1':
      return 'Wolfair'
    case 'Faireaf_SignWitch_1':
      return 'Aether'
    case 'Faireaf_Layla_1':
      return 'Lilim'
    case 'Faireaf_Ame_chan_1':
      return 'Cantis'
    case 'Faireaf_P1_1':
      return 'Caliy'

    case 'Golem_Golem_1':
      return 'Golem'
    case 'Golem_UPA_1':
      return 'Looper'
    case 'Golem_DEKAUSA_1':
      return 'Rabilen'
    case 'Golem_Kids_Hero_1':
      return 'Patrolem'
    case 'Golem_Kids_Villain_1':
      return 'Pazuzu'
    case 'Golem_Planetman_1':
      return 'Wooden'
    case 'Golem_Ossan_Paradise_1':
      return 'Quackle'

    case 'Tofu_Golem_1':
      return 'Koya'
    case 'Tofu_Tofu_1':
      return 'Tofu'
    case 'Tofu_SignWitch_1':
      return 'Neri-yokan'
    case 'Tofu_Yamato_1':
      return 'Timekeeper'
    case 'Tofu_DEKAUSA_1':
      return 'Sainome'
    case 'Tofu_Icelime_1':
      return 'Sainome'
    case 'Tofu_Planetman_1':
      return 'Yaki-tofu'

    case 'Unicorn_Unicorn_1':
      return 'Unicorn'
    case 'Unicorn_Valius_1':
      return 'Crimson '
    case 'Unicorn_AstarCats_1':
      return 'Skywalker'
    case 'Unicorn_ODENPETS_1':
      return 'Soundhorse'
    case 'Unicorn_UPA_1':
      return 'Kelpie'
    case 'Unicorn_CCT_1':
      return 'Burhimu'
    case 'Unicorn_Planetman_1':
      return 'Hanamiuma'

    case 'Valius_Unicorn_1':
      return 'Wolhorn'
    case 'Valius_Valius_1':
      return 'Valius '
    case 'Valius_ODENPETS_1':
      return 'Stargazer'
    case 'Valius_DEKAUSA_1':
      return 'Braze-hopper'
    case 'Valius_CCT_1':
      return 'Valy'
    case 'Valius_Kids_Villain_1':
      return 'Night-terror'
    case 'Valius_Ossan_Paradise_1':
      return 'Sky-fang'

    case 'AstarCats_Faireaf_1':
      return 'FairyCats'
    case 'AstarCats_Tofu_1':
      return 'TofuCats '
    case 'AstarCats_AstarCats_1':
      return 'AstarCats'
    case 'AstarCats_SignWitch_1':
      return 'WitchCats'
    case 'AstarCats_Hiyori_1':
      return 'WafukuCats'
    case 'AstarCats_Kids_Villain_1':
      return 'VillainCats'
    case 'AstarCats_Ossan_Paradise_1':
      return 'MaskCats'

    case 'SignWitch_SignWitch_1':
      return 'Aries'
    case 'SignWitch_Valius_1':
      return 'Taurus '
    case 'SignWitch_AstarCats_1':
      return 'Gem'
    case 'SignWitch_AstarCats_2':
      return 'Meg'
    case 'SignWitch_Unicorn_1':
      return 'Cancer'
    case 'SignWitch_P1_1':
      return 'Leo'
    case 'SignWitch_Faireaf_1':
      return 'Virgilia'
    case 'SignWitch_Planetman_1':
      return 'Libra'
    case 'SignWitch_UPA_1':
      return 'Scorpius '
    case 'SignWitch_Layla_1':
      return 'Sagittarius'
    case 'SignWitch_Tofu_1':
      return 'Capricorn'
    case 'SignWitch_Hiyori_1':
      return 'Aquarius'
    case 'SignWitch_Ame_chan_1':
      return 'Pisces'

    case 'Layla_Faireaf_1':
      return 'Bella'
    case 'Layla_Valius_1':
      return 'Luna '
    case 'Layla_SignWitch_1':
      return 'Olivia'
    case 'Layla_Layla_1':
      return 'Layla'
    case 'Layla_Hiyori_1':
      return 'Matoi'
    case 'Layla_Icelime_1':
      return 'Sora'
    case 'Layla_P1_1':
      return 'Eve'

    case 'ODENPETS_ODENPETS_1':
      return 'Pochi'
    case 'ODENPETS_DEKAUSA_1':
      return 'Laby '
    case 'ODENPETS_P1_1':
      return 'Nyanpen'
    case 'ODENPETS_Ame_chan_1':
      return 'Kumatama'
    case 'ODENPETS_Kids_Hero_1':
      return 'Monta'

    case 'UPA_Golem_1':
      return 'UPA[Gorem]'
    case 'UPA_AstarCats_1':
      return 'UPA[AC] '
    case 'UPA_ODENPETS_1':
      return 'UPA[ODEN]'
    case 'UPA_UPA':
      return 'UPA'
    case 'UPA_Yamato_1':
      return 'UPA[1912]'
    case 'UPA_Kids_Villain_1':
      return 'UPA[Villain]'
    case 'UPA_Ossan_Paradise_1':
      return 'UPA[Ossan]'

    case 'Hiyori_Faireaf_1':
      return 'Mei'
    case 'Hiyori_Unicorn_1':
      return 'Orika '
    case 'Hiyori_Valius_1':
      return 'Akane'
    case 'Hiyori_Layla_1':
      return 'Ayano'
    case 'Hiyori_Hiyori_1':
      return 'Hiyori'
    case 'Hiyori_Icelime_1':
      return 'Nanami'
    case 'Hiyori_Ame_chan_1':
      return 'Yui'

    case 'Yamato_Tofu_1':
      return 'Yamato[White]'
    case 'Yamato_AstarCats_1':
      return 'Yamato[T-Shirt] '
    case 'Yamato_ODENPETS_1':
      return 'Yamato[Waiter]'
    case 'Yamato_UPA_1':
      return 'Yamato[UPA]'
    case 'Yamato_Yamato_1':
      return 'Yamato'
    case 'Yamato_Ame_chan_1':
      return 'Yamato[Dress]'
    case 'Yamato_P1_1':
      return 'Yamato[X]'

    case 'DEKAUSA_Golem_1':
      return 'GOLIATH'
    case 'DEKAUSA_Tofu_1':
      return 'SOY '
    case 'DEKAUSA_ODENPETS_1':
      return 'DEKALABY'
    case 'DEKAUSA_Yamato_1':
      return 'BANCHO'
    case 'DEKAUSA_DEKAUSA_1':
      return 'DEKAUSA'
    case 'DEKAUSA_CCT_1':
      return 'DEKACONI'
    case 'DEKAUSA_Planetman_1':
      return 'TARU-USA'

    case 'CCT_CCT_1':
      return 'Coni'
    case 'CCT_CCT_2':
      return 'Mous '
    case 'CCT_CCT_3':
      return 'Bot'
    case 'CCT_CCT_4':
      return 'Conic'

    case 'Icelime_Unicorn_1':
      return 'Vanilla'
    case 'Icelime_UPA_1':
      return 'Emerald-sufer '
    case 'Icelime_Yamato_1':
      return 'Ogaki-blue'
    case 'Icelime_DEKAUSA_1':
      return 'Bunny-bunny'
    case 'Icelime_CCT_1':
      return 'Caramel-fromage'
    case 'Icelime_Icelime_1':
      return 'Icelime'
    case 'Icelime_Kids_Hero_1':
      return 'Star-berry'

    case 'Ame_chan_Golem_1':
      return 'Ame-chan[Powered]'
    case 'Ame_chan_Layla_1':
      return 'Ame-chan[Imp] '
    case 'Ame_chan_Hiyori_1':
      return 'Ame-chan[Wafuku]'
    case 'Ame_chan_Yamato_1':
      return 'Ame-chan[School]'
    case 'Ame_chan_Icelime_1':
      return 'Ame-chan[Summer]'
    case 'Ame_chan_Ame_chan_1':
      return 'Ame-chan'
    case 'Ame_chan_Kids_Villain_1':
      return 'Ame-chan[Villain]'

    case 'Kids_Hero_Kids_Hero_1':
      return 'Kids Hero 1'
    case 'Kids_Hero_Kids_Hero_2':
      return 'Kids Hero 2 '
    case 'Kids_Hero_Kids_Hero_3':
      return 'Kids Hero 3'
    case 'Kids_Hero_Kids_Hero_4':
      return 'Kids Hero 4'
    case 'Kids_Hero_Kids_Hero_5':
      return 'Kids Hero 5'

    case 'Kids_Villain_Kids_Villain_1':
      return 'Kids Villain 1'
    case 'Kids_Villain_Kids_Villain_2':
      return 'Kids Villain 2'
    case 'Kids_Villain_Kids_Villain_3':
      return 'Kids Villain 3'
    case 'Kids_Villain_Kids_Villain_4':
      return 'Kids Villain 4'
    case 'Kids_Villain_Kids_Villain_5':
      return 'Kids Villain 5'

    case 'Planetman_Golem_1':
      return 'Sake Metal PlanetMan'
    case 'Planetman_Unicorn_1':
      return 'Sake Shiraki PlanetMan '
    case 'Planetman_AstarCats_1':
      return 'Matatabi Barrel PlanetMan'
    case 'Planetman_CCT_1':
      return 'Sake Pottery PlanetMan'
    case 'Planetman_Kids_Hero_1':
      return 'Kids Barrel PlanetMan'
    case 'Planetman_Planetman_1':
      return 'Sake Burrel PlanetMan'
    case 'Planetman_Ossan_Paradise_1':
      return 'Sake Cup PlanetMan'

    case 'P1_Faireaf_1':
      return 'F2'
    case 'P1_SignWitch_1':
      return 'W3'
    case 'P1_Layla_1':
      return 'G20'
    case 'P1_Hiyori_1':
      return 'J8'
    case 'P1_Icelime_1':
      return 'J8'
    case 'P1_Kids_Hero_1':
      return 'H17'
    case 'P1_P1_1':
      return 'P-1'

    case 'Ossan_Paradise_Ossan_Paradise_1':
      return 'Ossan Paradise 1'
    case 'Ossan_Paradise_Ossan_Paradise_2':
      return 'Ossan Paradise 2'
    case 'Ossan_Paradise_Ossan_Paradise_3':
      return 'Ossan Paradise 3'
    case 'Ossan_Paradise_Ossan_Paradise_4':
      return 'Ossan Paradise 4'
    case 'Ossan_Paradise_Ossan_Paradise_5':
      return 'Ossan Paradise 5'

    default:
      return ''
  }
}
export const converNamePublicMainSubSeed = (seed) => {
  switch (seed) {
    case 'Faireaf':
      return 'Faireaf'
    case 'Golem':
      return 'Golem'
    case 'Tofu':
      return 'Tofu'
    case 'Unicorn':
      return 'Unicorn'
    case 'Valius':
      return 'Valius'
    case 'AstarCats':
      return 'Astar Cats'
    case 'SignWitch':
      return 'Sign Witch'
    case 'Layla':
      return 'Layla'
    case 'ODENPETS':
      return 'ODENPETS'
    case 'UPA':
      return 'UPA'
    case 'Hiyori':
      return 'Hiyori'
    case 'Yamato':
      return 'Yamato'
    case 'DEKAUSA':
      return 'DEKAUSA'
    case 'CCT':
      return 'Candy Cony Town'
    case 'Icelime':
      return 'Icelime'
    case 'Ame_chan':
      return 'Ame-chan'
    case 'Kids_Hero':
      return 'Kids Hero'
    case 'Kids_Villain':
      return 'Kids Villain'
    case 'Planetman':
      return 'Sake Barrel PlanetMan'
    case 'P1':
      return 'P1'
    case 'Ossan_Paradise':
      return 'Ossan Paradise'
    default:
      return ''
  }
}

export const getMaxParameter = (hp, str, int, dex, agi, vit) => {
  const params = { HP: hp, STR: str, INT: int, DEX: dex, AGI: agi, VIT: vit }

  return Object.keys(params).reduce(
    (maxParam, key) => (params[key] > params[maxParam] ? key : maxParam),
    'HP',
  )
}
export const getRankbyValue = (rank) => {
  switch (rank) {
    case 7:
      return 'SP'
    case 6:
      return 'S'
    case 5:
      return 'A'
    case 4:
      return 'B'
    case 3:
      return 'C'
    case 2:
      return 'D'
    case 1:
      return 'E'
    case 0:
      return 'F'
    default:
      return 'F'
  }
}
export const getTypeCrystalCoach = (value) => {
  switch (value) {
    case 5:
      return 'VIT'
    case 4:
      return 'AGI'
    case 3:
      return 'DEX'
    case 2:
      return 'INT'
    case 1:
      return 'STR'
    case 0:
      return 'HP'
    default:
      return ''
  }
}
export function findEnNameByItemId(data, itemId, language) {
  return (
    (language === 'ja'
      ? data?.item_name?.find((item) => item.item_id === itemId)?.jp_name
      : data?.item_name?.find((item) => item.item_id === itemId)?.en_name) ||
    null
  )
}
